module.exports = __webpack_public_path__ + "static/img/wxicon.e560c4a5.png";